{
  "got-it": "Verstanden",
  "mercury.email.footer.sent-by": "Diese Nachricht wurde von Atlassian Focus gesendet.",
  "mercury.email.footer.unsubscribe": "Abonnement kündigen",
  "mercury.focus-areas.arrow-icon.alt": "Symbol: Pfeil",
  "mercury.focus-areas.arrow-right-icon.alt": "Symbol: Pfeil nach rechts",
  "mercury.focus-areas.calendar-icon.alt": "Symbol: Kalender",
  "mercury.focus-areas.date-changed": "Datum geändert",
  "mercury.focus-areas.focus-area.alt": "Symbol: Fokusbereich",
  "mercury.focus-areas.focus-footer.alt": "Atlassian-Fußzeile",
  "mercury.focus-areas.focus-icon.alt": "Symbol: Fokusbereich",
  "mercury.focus-areas.for": "for",
  "mercury.focus-areas.heading": "You're following {total} active focus areas, here's the breakdown.",
  "mercury.focus-areas.no-target-date.alt": "Kein Zieldatum festgelegt",
  "mercury.focus-areas.status-changed": "Status geändert",
  "mercury.focus-areas.view-area": "Fokusbereich anzeigen",
  "mercury.focus.catch.up.link": "Direkt zu Atlassian Focus",
  "mercury.focus.catch.up.text": "Möchten Sie sich über frühere Updates informieren? {link}",
  "mercury.mercury-monthly-digest.message-template.email.subject.no-translate": "{name}, hier sind Ihre monatlichen Fokusbereichs-Updates.",
  "mercury.message-templates.edit-focus-area-heirarchy-spotlight-body": "Änderungen an der Hierarchie können Sie jederzeit über die Einstellungen vornehmen.",
  "mercury.message-templates.edit-focus-area-heirarchy-spotlight-heading": "Hierarchie der Fokusbereiche bearbeiten"
}